var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { allProductInfos } from '@marketing/content';
var ProductCardAtStart = function (_a) {
    var productId = _a.productId;
    return (_jsxs("div", __assign({ className: "flex justify-center items-center gap-4" }, { children: [_jsx("div", __assign({ className: "size-16 min-h-16 min-w-[4rem] bg-bone object-cover object-center rounded-sm2 border-2 border-shoe" }, { children: _jsx("img", { className: "w-full h-auto", src: allProductInfos[productId].image.src, alt: allProductInfos[productId].image.alt }) })), _jsxs("div", __assign({ className: "text-left" }, { children: [_jsx("p", __assign({ className: "font-medium" }, { children: allProductInfos[productId].displayName })), _jsx("p", { children: "Added to cart" })] }))] })));
};
export default ProductCardAtStart;
